import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivationEnd, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Auth } from 'aws-amplify';
import { AuthService } from 'src/app/auth-o3/shared/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit{
  environment = '';
  signedIn = false;
  user: string = undefined;
  email: string = undefined;
  identityProviders = [];
  public formFields = {
    signIn: {
      username: {
        placeholder: 'Username',
        isRequired: true,
        label: 'Username:',
      },
      password: {
        placeholder: 'Password',
        isRequired: true,
        label: 'Password:',
      },
    },
    resetPassword: {
      username: {
        placeholder: 'Username',
        isRequired: true,
        label: 'Username:',
      },
    },
    setupTOTP: {
      QR: {
        totpIssuer: 'inSPire Platform',
      },
    },
  };
  constructor(private authService:AuthService,public authenticator: AuthenticatorService, private router: Router) {
    this.authService.onMfaEnvironment.subscribe((environment) => {
      this.environment = environment;
      this.formFields.setupTOTP.QR.totpIssuer =
        'inSPire Platform - ' + environment;
    });

    this.authService.onUserSession.subscribe((session) => {
      this.signedIn = session?.isValid();
      this.user =
        session?.isValid() && session.idToken.payload['cognito:username'];
      this.email = session?.isValid() && session.idToken.payload.email;
    });

    this.authService.onAuthSSO.subscribe((identityProviders) => {
      this.identityProviders = identityProviders;
    });
  }
  async ngOnInit() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        const redirectUrl = sessionStorage.getItem('redirectAfterLogin') || '/';
        sessionStorage.removeItem('redirectAfterLogin');
        this.router.navigateByUrl(redirectUrl || '/');
      }
    } catch {
      // Not signed in – stay on login
    }
  }

  handleSignInClick(provider: string) {
    this.authenticator.toFederatedSignIn({
      provider: provider,
    });
  }

   navigationInterceptor(event: RouterEvent): void {
      if (event instanceof NavigationStart) {

      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {

      }
      if (event instanceof ActivationEnd) {

      }
    }
 }
